// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.HeroSection_heroContainer__c2yOl {
  display: flex;
  min-height: 100vh;
  background-color: #0f0f0f;
  color: #f5f5f5;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;
}

/* Sidebar Styles */
.HeroSection_sidebar__9wWRi {
  width: 260px;
  background-color: #1a1a1a;
  display: flex;
  flex-direction: column;
  border-right: 1px solid #2a2a2a;
  padding-top: 5.8rem;
}

.HeroSection_logo__8arhM {
  padding: 24px 20px;
  border-bottom: 1px solid #2a2a2a;
}

.HeroSection_logo__8arhM span {
  font-size: 1.5rem;
  font-weight: 700;
  background: linear-gradient(90deg, #ff3333, #ff0000);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.HeroSection_navigation__JOAeP {
  display: flex;
  flex-direction: column;
  padding: 20px 0;
  flex: 1 1;
}

.HeroSection_navItem__M4025 {
  display: flex;
  align-items: center;
  padding: 12px 20px;
  margin-bottom: 8px;
  border: none;
  background: transparent;
  color: #b0b0b0;
  font-size: 0.95rem;
  cursor: pointer;
  transition: all 0.2s ease;
  border-left: 3px solid transparent;
  text-align: left;
  position: relative;
}

.HeroSection_navItem__M4025:hover {
  background-color: rgba(255, 255, 255, 0.05);
  color: #ffffff;
}

.HeroSection_navItem__M4025.HeroSection_active__M\\+Na0 {
  background-color: rgba(255, 51, 51, 0.1);
  border-left: 3px solid #ff3333;
  color: #ff3333;
}

.HeroSection_navItem__M4025 svg {
  margin-right: 12px;
}

.HeroSection_navArrow__0KDK7 {
  position: absolute;
  right: 15px;
  opacity: 0;
  transition: all 0.2s ease;
}

.HeroSection_navItem__M4025:hover .HeroSection_navArrow__0KDK7,
.HeroSection_navItem__M4025.HeroSection_active__M\\+Na0 .HeroSection_navArrow__0KDK7 {
  opacity: 1;
  transform: translateX(3px);
}

.HeroSection_uploadButton__RWsNN {
  padding: 16px;
  margin-top: auto;
  border-top: 1px solid #2a2a2a;
}

.HeroSection_uploadButton__RWsNN button {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 12px;
  background: linear-gradient(90deg, #ff3333, #c70000);
  border: none;
  border-radius: 6px;
  color: white;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
}

.HeroSection_uploadButton__RWsNN button:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(255, 0, 0, 0.2);
}

.HeroSection_uploadButton__RWsNN button svg {
  margin-right: 8px;
}

/* Main Content Area */
.HeroSection_mainContent__QZ8AN {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  background-color: #0f0f0f;
  overflow-y: auto;
}

.HeroSection_header__DvthP {
  padding: 3.35rem 40px;
  border-bottom: 1px solid #2a2a2a;
}

.HeroSection_header__DvthP h1 {
  font-size: 1.8rem;
  font-weight: 600;
  margin-bottom: 8px;
  color: #ffffff;
}

.HeroSection_header__DvthP p {
  color: #a0a0a0;
  font-size: 1rem;
}

.HeroSection_contentArea__ZCnLf {
  flex: 1 1;
  padding: 32px 40px;
  display: flex;
  flex-direction: column;
}

/* Upload Area Styles */
.HeroSection_uploadArea__AiVhm {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  flex: 1 1;
}

.HeroSection_uploadBox__vYeXM {
  width: 100%;
  max-width: 600px;
  height: 350px;
  background-color: #1a1a1a;
  border: 2px dashed #3a3a3a;
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 32px;
  transition: all 0.3s ease;
}

.HeroSection_uploadBox__vYeXM:hover {
  border-color: #ff3333;
  background-color: rgba(255, 51, 51, 0.05);
}

.HeroSection_uploadBox__vYeXM svg {
  color: #ff3333;
  margin-bottom: 16px;
}

.HeroSection_uploadBox__vYeXM h3 {
  font-size: 1.5rem;
  font-weight: 600;
  margin-bottom: 12px;
}

.HeroSection_uploadBox__vYeXM p {
  color: #a0a0a0;
  margin-bottom: 24px;
  text-align: center;
}

.HeroSection_fileInput__90R4R {
  display: none;
}

.HeroSection_uploadLabel__2veP0 {
  padding: 10px 24px;
  background-color: #ff3333;
  color: white;
  border-radius: 6px;
  cursor: pointer;
  font-weight: 500;
  transition: all 0.2s ease;
}

.HeroSection_uploadLabel__2veP0:hover {
  background-color: #e62e2e;
  transform: translateY(-2px);
}

.HeroSection_cancelButton__7gvY4 {
  margin-top: 16px;
  background: transparent;
  border: 1px solid #3a3a3a;
  color: #a0a0a0;
  padding: 8px 20px;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.HeroSection_cancelButton__7gvY4:hover {
  border-color: #ff3333;
  color: #ff3333;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .HeroSection_heroContainer__c2yOl {
    flex-direction: column;
  }
  
  .HeroSection_sidebar__9wWRi {
    width: 100%;
    border-right: none;
    border-bottom: 1px solid #2a2a2a;
  }
  
  .HeroSection_navigation__JOAeP {
    flex-direction: row;
    overflow-x: auto;
    padding: 10px;
    justify-content: space-between;
  }
  
  .HeroSection_navItem__M4025 {
    flex: 1 1;
    flex-direction: column;
    padding: 10px;
    border-left: none;
    border-bottom: 3px solid transparent;
    text-align: center;
  }
  
  .HeroSection_navItem__M4025.HeroSection_active__M\\+Na0 {
    border-left: none;
    border-bottom: 3px solid #ff3333;
  }
  
  .HeroSection_navItem__M4025 svg {
    margin-right: 0;
    margin-bottom: 5px;
  }
  
  .HeroSection_navArrow__0KDK7 {
    display: none;
  }
  
  .HeroSection_header__DvthP {
    padding: 20px;
  }
  
  .HeroSection_contentArea__ZCnLf {
    padding: 20px;
  }
}`, "",{"version":3,"sources":["webpack://./src/admin/pages/content/components/HeroSection.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,iBAAiB;EACjB,yBAAyB;EACzB,cAAc;EACd,mEAAmE;AACrE;;AAEA,mBAAmB;AACnB;EACE,YAAY;EACZ,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,oDAAoD;EACpD,6BAA6B;EAC7B,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,SAAO;AACT;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,kCAAkC;EAClC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,2CAA2C;EAC3C,cAAc;AAChB;;AAEA;EACE,wCAAwC;EACxC,8BAA8B;EAC9B,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,yBAAyB;AAC3B;;AAEA;;EAEE,UAAU;EACV,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,aAAa;EACb,oDAAoD;EACpD,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,2CAA2C;AAC7C;;AAEA;EACE,iBAAiB;AACnB;;AAEA,sBAAsB;AACtB;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,aAAa;EACb,sBAAsB;AACxB;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,SAAO;AACT;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,0BAA0B;EAC1B,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,yCAAyC;AAC3C;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,yBAAyB;EACzB,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA,2BAA2B;AAC3B;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,gCAAgC;EAClC;;EAEA;IACE,mBAAmB;IACnB,gBAAgB;IAChB,aAAa;IACb,8BAA8B;EAChC;;EAEA;IACE,SAAO;IACP,sBAAsB;IACtB,aAAa;IACb,iBAAiB;IACjB,oCAAoC;IACpC,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,gCAAgC;EAClC;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;AACF","sourcesContent":[".heroContainer {\n  display: flex;\n  min-height: 100vh;\n  background-color: #0f0f0f;\n  color: #f5f5f5;\n  font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;\n}\n\n/* Sidebar Styles */\n.sidebar {\n  width: 260px;\n  background-color: #1a1a1a;\n  display: flex;\n  flex-direction: column;\n  border-right: 1px solid #2a2a2a;\n  padding-top: 5.8rem;\n}\n\n.logo {\n  padding: 24px 20px;\n  border-bottom: 1px solid #2a2a2a;\n}\n\n.logo span {\n  font-size: 1.5rem;\n  font-weight: 700;\n  background: linear-gradient(90deg, #ff3333, #ff0000);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n}\n\n.navigation {\n  display: flex;\n  flex-direction: column;\n  padding: 20px 0;\n  flex: 1;\n}\n\n.navItem {\n  display: flex;\n  align-items: center;\n  padding: 12px 20px;\n  margin-bottom: 8px;\n  border: none;\n  background: transparent;\n  color: #b0b0b0;\n  font-size: 0.95rem;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  border-left: 3px solid transparent;\n  text-align: left;\n  position: relative;\n}\n\n.navItem:hover {\n  background-color: rgba(255, 255, 255, 0.05);\n  color: #ffffff;\n}\n\n.navItem.active {\n  background-color: rgba(255, 51, 51, 0.1);\n  border-left: 3px solid #ff3333;\n  color: #ff3333;\n}\n\n.navItem svg {\n  margin-right: 12px;\n}\n\n.navArrow {\n  position: absolute;\n  right: 15px;\n  opacity: 0;\n  transition: all 0.2s ease;\n}\n\n.navItem:hover .navArrow,\n.navItem.active .navArrow {\n  opacity: 1;\n  transform: translateX(3px);\n}\n\n.uploadButton {\n  padding: 16px;\n  margin-top: auto;\n  border-top: 1px solid #2a2a2a;\n}\n\n.uploadButton button {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  padding: 12px;\n  background: linear-gradient(90deg, #ff3333, #c70000);\n  border: none;\n  border-radius: 6px;\n  color: white;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.uploadButton button:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(255, 0, 0, 0.2);\n}\n\n.uploadButton button svg {\n  margin-right: 8px;\n}\n\n/* Main Content Area */\n.mainContent {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  background-color: #0f0f0f;\n  overflow-y: auto;\n}\n\n.header {\n  padding: 3.35rem 40px;\n  border-bottom: 1px solid #2a2a2a;\n}\n\n.header h1 {\n  font-size: 1.8rem;\n  font-weight: 600;\n  margin-bottom: 8px;\n  color: #ffffff;\n}\n\n.header p {\n  color: #a0a0a0;\n  font-size: 1rem;\n}\n\n.contentArea {\n  flex: 1;\n  padding: 32px 40px;\n  display: flex;\n  flex-direction: column;\n}\n\n/* Upload Area Styles */\n.uploadArea {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n  flex: 1;\n}\n\n.uploadBox {\n  width: 100%;\n  max-width: 600px;\n  height: 350px;\n  background-color: #1a1a1a;\n  border: 2px dashed #3a3a3a;\n  border-radius: 12px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 32px;\n  transition: all 0.3s ease;\n}\n\n.uploadBox:hover {\n  border-color: #ff3333;\n  background-color: rgba(255, 51, 51, 0.05);\n}\n\n.uploadBox svg {\n  color: #ff3333;\n  margin-bottom: 16px;\n}\n\n.uploadBox h3 {\n  font-size: 1.5rem;\n  font-weight: 600;\n  margin-bottom: 12px;\n}\n\n.uploadBox p {\n  color: #a0a0a0;\n  margin-bottom: 24px;\n  text-align: center;\n}\n\n.fileInput {\n  display: none;\n}\n\n.uploadLabel {\n  padding: 10px 24px;\n  background-color: #ff3333;\n  color: white;\n  border-radius: 6px;\n  cursor: pointer;\n  font-weight: 500;\n  transition: all 0.2s ease;\n}\n\n.uploadLabel:hover {\n  background-color: #e62e2e;\n  transform: translateY(-2px);\n}\n\n.cancelButton {\n  margin-top: 16px;\n  background: transparent;\n  border: 1px solid #3a3a3a;\n  color: #a0a0a0;\n  padding: 8px 20px;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.cancelButton:hover {\n  border-color: #ff3333;\n  color: #ff3333;\n}\n\n/* Responsive adjustments */\n@media (max-width: 768px) {\n  .heroContainer {\n    flex-direction: column;\n  }\n  \n  .sidebar {\n    width: 100%;\n    border-right: none;\n    border-bottom: 1px solid #2a2a2a;\n  }\n  \n  .navigation {\n    flex-direction: row;\n    overflow-x: auto;\n    padding: 10px;\n    justify-content: space-between;\n  }\n  \n  .navItem {\n    flex: 1;\n    flex-direction: column;\n    padding: 10px;\n    border-left: none;\n    border-bottom: 3px solid transparent;\n    text-align: center;\n  }\n  \n  .navItem.active {\n    border-left: none;\n    border-bottom: 3px solid #ff3333;\n  }\n  \n  .navItem svg {\n    margin-right: 0;\n    margin-bottom: 5px;\n  }\n  \n  .navArrow {\n    display: none;\n  }\n  \n  .header {\n    padding: 20px;\n  }\n  \n  .contentArea {\n    padding: 20px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"heroContainer": `HeroSection_heroContainer__c2yOl`,
	"sidebar": `HeroSection_sidebar__9wWRi`,
	"logo": `HeroSection_logo__8arhM`,
	"navigation": `HeroSection_navigation__JOAeP`,
	"navItem": `HeroSection_navItem__M4025`,
	"active": `HeroSection_active__M+Na0`,
	"navArrow": `HeroSection_navArrow__0KDK7`,
	"uploadButton": `HeroSection_uploadButton__RWsNN`,
	"mainContent": `HeroSection_mainContent__QZ8AN`,
	"header": `HeroSection_header__DvthP`,
	"contentArea": `HeroSection_contentArea__ZCnLf`,
	"uploadArea": `HeroSection_uploadArea__AiVhm`,
	"uploadBox": `HeroSection_uploadBox__vYeXM`,
	"fileInput": `HeroSection_fileInput__90R4R`,
	"uploadLabel": `HeroSection_uploadLabel__2veP0`,
	"cancelButton": `HeroSection_cancelButton__7gvY4`
};
export default ___CSS_LOADER_EXPORT___;
